import { apiClient } from '@/lib/apiClient';
import type {
  ProjetoOrcamento, SalvarOrcamentoRequest,
  ProjetoDespesa, SalvarDespesaRequest, OrcadoRealizado,
  ProjetoMedicao, SalvarMedicaoRequest, FaturamentoResultado,
} from '../types';

const base = (projetoId: number) => `/api/projetos/${projetoId}`;

export const financeiroService = {
  listarOrcamento: (projetoId: number) =>
    apiClient.get<ProjetoOrcamento[]>(`${base(projetoId)}/orcamento`).then(r => r.data),
  salvarOrcamento: (projetoId: number, req: SalvarOrcamentoRequest) =>
    apiClient.put<ProjetoOrcamento>(`${base(projetoId)}/orcamento`, req).then(r => r.data),

  listarDespesas: (projetoId: number) =>
    apiClient.get<ProjetoDespesa[]>(`${base(projetoId)}/despesas`).then(r => r.data),
  criarDespesa: (projetoId: number, req: SalvarDespesaRequest) =>
    apiClient.post<ProjetoDespesa>(`${base(projetoId)}/despesas`, req).then(r => r.data),
  atualizarDespesa: (projetoId: number, despId: number, req: SalvarDespesaRequest) =>
    apiClient.put<ProjetoDespesa>(`${base(projetoId)}/despesas/${despId}`, req).then(r => r.data),
  excluirDespesa: (projetoId: number, despId: number) =>
    apiClient.delete(`${base(projetoId)}/despesas/${despId}`).then(r => r.data),

  orcadoRealizado: (projetoId: number) =>
    apiClient.get<OrcadoRealizado>(`${base(projetoId)}/orcado-realizado`).then(r => r.data),

  // Medições / faturamento
  listarMedicoes: (projetoId: number) =>
    apiClient.get<ProjetoMedicao[]>(`${base(projetoId)}/medicoes`).then(r => r.data),
  criarMedicao: (projetoId: number, req: SalvarMedicaoRequest) =>
    apiClient.post<ProjetoMedicao>(`${base(projetoId)}/medicoes`, req).then(r => r.data),
  atualizarMedicao: (projetoId: number, medId: number, req: SalvarMedicaoRequest) =>
    apiClient.put<ProjetoMedicao>(`${base(projetoId)}/medicoes/${medId}`, req).then(r => r.data),
  excluirMedicao: (projetoId: number, medId: number) =>
    apiClient.delete(`${base(projetoId)}/medicoes/${medId}`).then(r => r.data),
  faturarMedicao: (projetoId: number, medId: number, dtVencimento: string) =>
    apiClient.post<FaturamentoResultado>(`${base(projetoId)}/medicoes/${medId}/faturar`, { dtVencimento }).then(r => r.data),
  cancelarMedicao: (projetoId: number, medId: number) =>
    apiClient.post<ProjetoMedicao>(`${base(projetoId)}/medicoes/${medId}/cancelar`, {}).then(r => r.data),
};
